import { Commands } from "../../core/src/commands/CommandEnum";
import CommandManager from "../../core/src/commands/CommandManager";
import Configs from "../vendorConfigs/Configs";
import CommManager from "../../core/src/controllers/CommManager";
import BetModel from "../../core/src/model/BetModel";
import ErrorModel from "../../core/src/model/ErrorModel";
import SpinModel from "../../core/src/model/SpinModel";
import RequestRegister from "../../core/src/server/requests/RequestRegister";
import { State } from "../../core/src/states/State";
import UIController from "../../core/src/ui/UIController";
import { UIUpdateEvent } from "../../core/src/ui/UIUpdateEvents";
import { VendorCommandsEnum } from "../commands/VendorCommandsEnum";
import VendorModel from "../model/VendorModel";
import BuyFeatureModel from "../../core/src/model/BuyFeatureModel";

export default class VendorFinishState extends State {

    protected _canExit: boolean = false;

    enter(){
        super.enter();
        this._canExit = false;

        // Commented out, because this causes issues with spines according to H.Hristov
        // const scene = ViewManager.getLayer(
        //     DefaultLayers.Reels
        // ).getCurrentScene();

        // const reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
        // let reels = Array.from(Array(reelGroup.reels.length).keys());
        // let result = SpinModel.getFinalSymsForReels(reels);
        // reelGroup.showFinalSymbols(result);

        // if we are in free games we fake bet field with FG chosen bet
        // and don't want to write the real bet
        if(VendorModel.freeGames == null || VendorModel.freeGames == undefined) {
            CommandManager.execute(Commands.UPDATE_UI);
        }

        // if the Dream Drop Jackpot is falen we don't send finish round request
        // 'golden freez' must be visible until the jackpot is won
        if(!this.checkDDIsFalen()) {

            CommManager.send(RequestRegister.get("finishRound"),
                (data) => {
                    this.onResponseReceived(data);
                },
                this,
                (data) => {
                    ErrorModel.update(data);
                    this.onResponseReceived();
                }
            );
        }
    }

    protected checkDDIsFalen(): boolean {
        return false;
    }

    public canExit(): boolean {
        return this._canExit;
    }

    protected updateBalance(): void {
        UIController.updateFields(UIUpdateEvent.Balance);
    }

    protected getBet(): number {
        let result = BetModel.totalBet;
        if (BuyFeatureModel.isInBuyFeatureFreeSpins) {
            result = BuyFeatureModel.getTotalBet();
        }

        return result
    }
    protected onResponseReceived(data?: any) {

        const hasFinishResponse = Configs.game.clientConfig?.disableSpinUntilGameFinished;
        // May be here myst call BetModel.update() !!!
        if (data?.b) {
            BetModel.balance = data?.b;
            UIController.updateFields(UIUpdateEvent.Balance);
        }
        this.updateBalance();
        let payload = {
            balance: BetModel.balance,
            bet: this.getBet(),
            win: {
                win: SpinModel.accumulatedWin
            },
            playResponse: {
                roundType: SpinModel.roundType
            },
            finishedResponse: hasFinishResponse
                ? data
                : null
        };
        CommandManager.execute(VendorCommandsEnum.GAME_ROUND_ENDED, payload);

        BuyFeatureModel.isInBuyFeatureFreeSpins = false;
        SpinModel.roundFinish = true;
        this._canExit = true;
        this.exit();
    }
}
